module.exports = require("crypto");


//////////////////
// WEBPACK FOOTER
// external "crypto"
// module id = 22
// module chunks = 0